import { Row } from "antd";
import { FC, useEffect, useState } from "react";

import styles from "./index.less";

import { ReactComponent as PlayIcon } from "@/assets/images/chat/message/voice_play.svg";
import { ReactComponent as StopIcon } from "@/assets/images/chat/message/voice_stop.svg";

class AudioContext {
  private audio?: HTMLAudioElement;
  source = "";

  async play(src: string) {
    if (this.source === src) {
      this.audio?.play();
    } else {
      this.source = src;
      this.audio?.pause();
      this.audio = new Audio();
      this.audio.src = src;
      this.audio?.play();
    }
    const audio = this.audio!;
    return new Promise<void>((resolve) => {
      const cb = () => {
        audio.removeEventListener("ended", cb);
        audio.removeEventListener("pause", cb);
        resolve();
      };
      audio.addEventListener("ended", cb);
      audio.addEventListener("pause", cb);
    });
  }
  pause() {
    this.audio?.pause();
  }
}
const audioContext = new AudioContext();

const VoiceMessage: FC<{ url: string }> = ({ url }) => {
  const [isPlay, setIsPlay] = useState(false);
  const [loadingLines, setLoadingLines] = useState<number[]>([]);

  const initLoadingLines = () => {
    const lines = [] as number[];
    Array(15)
      .fill("")
      .forEach(() => {
        lines.push(Math.floor(Math.random() * 81) + 20);
      });
    setLoadingLines(lines);
  };

  useEffect(() => {
    if (url) {
      initLoadingLines();
    }
  }, [url]);

  return (
    <Row className={styles["voice-box"]}>
      <div
        className={styles["voice-action-icon"]}
        onClick={async () => {
          if (isPlay) {
            setIsPlay(false);
            audioContext.pause();
          } else {
            setIsPlay(true);
            await audioContext.play(url);
            setIsPlay(false);
          }
        }}
      >
        {isPlay ? (
          <StopIcon className={styles.icon} />
        ) : (
          <PlayIcon className={styles.icon} />
        )}
      </div>

      <div className={styles["voice-playing"]}>
        {loadingLines?.map((_, index) => {
          return (
            <div
              key={index}
              className={`${styles.line} ${
                isPlay ? styles[`line-${(index % 3) + 1}`] : ""
              }`}
            />
          );
        })}
      </div>
    </Row>
  );
};

export default VoiceMessage;
